import React from 'react';

const SwotArrowDownIcon = function SwotArrowDownIcon() {
  return (
    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" className="swot-arrow-down-icon">
      <path d="M5.43375 5.99924C5.65427 5.99207 5.86443 5.90571 6.02427 5.75655L10.5234 1.52061C10.8821 1.18248 10.8935 0.623154 10.5487 0.271319C10.2039 -0.0805148 9.6336 -0.0916252 9.27486 0.246504L5.40001 3.89229L1.52517 0.246504C1.16642 -0.0916252 0.596114 -0.0805148 0.251345 0.271319C-0.0934245 0.623154 -0.082096 1.18248 0.276647 1.52061L4.77575 5.75655C4.95246 5.9216 5.18994 6.00918 5.43375 5.99924Z" fill="#FEFEFD" />
    </svg>

  );
};

export default SwotArrowDownIcon;
